<template>
    <div class="motor-picker">
        <div class="row no-gutters" v-if="!selectedMotorGroup">
            <div class="col-12 col-md-4 col-lg-3 list-block" v-for="type in types" :key="type.name">
                <motor-type :type="type"></motor-type>
            </div>
        </div>
        <div v-else>
          <div class="list-block">
            <div class="motor-list"  style="max-width: 300px; min-height: auto;">
              <div class="heading">{{ selectedType.name }}</div>
              <div class="motors" style="padding-bottom: 10px;">
                <motor-picker-type-motor
                    :motor="selectedMotorGroup"
                    :is-available="selectedMotorGroup.available"
                ></motor-picker-type-motor>
                <div class="motor available" @click="cancel">
                  <span class="power">
                    {{ $t('powerpack.steps.step2.chooseAnother') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

  import MotorType from './MotorPickerType';
  import MotorPickerTypeMotor from './MotorPickerTypeMotor';


  export default {
    name: 'MotorPicker',

    components: {
      MotorType,
      MotorPickerTypeMotor,
    },

    computed: {
      ...mapState({
        selectedMotorGroup: state => state.preference.selectedMotorGroup,
      }),
      ...mapGetters({
        types: 'motors/types',
      }),
      selectedType() {
        if (!this.selectedMotorGroup) return null;

        return this.types.find((type) => {
          return type.motors.includes(this.selectedMotorGroup.motors[0]);
        });
      },
    },

    methods: {
      cancel() {
        this.$store.dispatch('preference/selectMotorGroup', null);
        this.$store.dispatch('preference/selectMotor', null);
        this.$store.dispatch('build/selectMotor', null);
        this.$store.dispatch('preference/resetOptions');
      }
    }
  }
</script>

<style lang="scss">
    .motor-picker {
        @media only screen and (max-width: 576px) {
            max-width: 270px;
            margin: 0 auto 0 0;
        }

        .list-block {
            max-width: 270px;
            margin: 0 10px 15px;

            &:first-child {
                margin-left: 10px;

                @media only screen and (max-width: 1110px) {
                    margin-left: 10px;
                }
            }

            .motor-list {
                box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
                max-width: 270px;
                min-height: 254px;
                position: relative;
                background-color: white;
                overflow-y: auto;

                &:after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 30px;
                    background-image: linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
                    z-index: 1;
                    pointer-events: none;
                }

                .heading {
                    font-size: 12px;
                    padding: 16px 20px 5px 15px;
                    font-family: neue-haas-grotesk-display, sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    /*box-shadow: 0 0 10px #d3d3d3;*/
                }

                .motors {
                    padding-bottom: 30px;
                    max-height: 206px;
                    overflow-y: auto;
                    -ms-overflow-style: none;

                    &::-webkit-scrollbar {
                        width: 0 !important
                    }
                }
            }
        }
    }
</style>
